module.exports = __webpack_public_path__ + "static/media/qr1.e0cf0092.jpg";